(() => {
	const initSliders = () => {
		const slideshows = document.querySelectorAll(".slideshow__swiper, .slideshow__swiper-new");

		slideshows.forEach((slideshow) => {
			const isNew = slideshow.classList.contains("slideshow__swiper-new");
			const autoplay = slideshow.getAttribute("data-autoplay") === "true";

			// Show slideshow immediately for faster loading
			if (isNew) {
				slideshow.classList.remove('slideshow__loading');
				slideshow.classList.add('swiper-initialized');
				
				// Hide skeleton loader immediately
				const skeleton = slideshow.previousElementSibling;
				if (skeleton && skeleton.classList.contains('slideshow__skeleton-new')) {
					skeleton.style.display = 'none';
				}
			}

			const options = {
				loop: true,
				allowTouchMove: true,
				loopedSlides: 7,
				navigation: {
					nextEl: isNew ? slideshow.querySelector(".slideshow__button-next-new") : ".slideshow__button-next",
					prevEl: isNew ? slideshow.querySelector(".slideshow__button-prev-new") : ".slideshow__button-prev",
				},
			};

			if (isNew) {
				options.pagination = {
					el: slideshow.querySelector(".slideshow__pagination-new"),
					bulletClass: 'swiper-bullet',
					bulletActiveClass: 'swiper-bullet-active',
					clickable: true,
					renderBullet: function(index, className) {
						return '<span class="' + className + ' swiper-bullet--svg-animation"><svg width="30" height="30" viewBox="0 0 28 28"><circle class="svg__circle" style="animation-duration: ' + this.el.getAttribute('data-duration') + 's" cx="14" cy="14" r="12" fill="none" stroke-width="2"></circle></svg></span>';
					}
				};
				options.slidesPerView = 1.1;
				options.centeredSlides = true;
				options.spaceBetween = 10;
				options.breakpoints = {
					768: {
						slidesPerView: 1.9,
						spaceBetween: 24,
					},
				};
				options.on = {
					slideChange: function() {
						this.pagination.render();
						this.pagination.update();
					}
				}
			}

			const swiper = new Swiper(slideshow, options);

			if (autoplay) {
				swiper.autoplay?.run?.();
				swiper.autoplay.running = true;

				slideshow.addEventListener("mouseenter", () => swiper.autoplay.pause());
				slideshow.addEventListener("mouseleave", () => swiper.autoplay.run());
			}

			if (swiper.slides.length < 2) {
				swiper.allowTouchMove = false;
			}

			if (swiper.slides.length > 1) {
				slideshow.classList.add("slideshow__swiper--multiple-slides");
			}
		});
	};

	initSliders();
	document.addEventListener("shopify:section:load", initSliders);
})();